import React from 'react';
import { ChevronDown } from 'lucide-react';

import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@dashboard/components/ui/dropdown-menu';
import { cn } from '@dashboard/lib/utils';

// A select that takes several, for conditional-logic rules where any ticked item
// satisfies the rule: the menu stays open while the seller ticks, and the
// trigger reads back what is ticked.
export default function MultiSelectMenu({
  id,
  placeholder,
  emptyText,
  items,
  selectedIds,
  onToggle,
}) {
  const selectedItems = items.filter(item => selectedIds.includes(item.id));

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        id={id}
        className={cn(
          'flex h-8 w-full items-center justify-between gap-1.5 rounded-lg border border-input bg-transparent dark:bg-input/30 py-2 pr-2 pl-2.5 text-left text-sm outline-none transition-colors select-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50',
          selectedItems.length === 0 && 'text-muted-foreground',
        )}
      >
        <span className="line-clamp-1">
          {selectedItems.length === 0
            ? placeholder
            : selectedItems.map(item => item.label).join(', ')}
        </span>
        <ChevronDown className="pointer-events-none size-4 shrink-0 text-muted-foreground" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-[var(--radix-dropdown-menu-trigger-width)]">
        {items.length === 0 && (
          <p className="px-2 py-1.5 text-sm text-gray-500 dark:text-muted-foreground">
            {emptyText}
          </p>
        )}
        {items.map(item => (
          <DropdownMenuCheckboxItem
            key={item.id}
            checked={selectedIds.includes(item.id)}
            onCheckedChange={() => onToggle(item.id)}
            onSelect={event => event.preventDefault()}
          >
            <span className="truncate">
              {item.label}
              {item.detail ? (
                <span className="text-gray-500 dark:text-muted-foreground"> · {item.detail}</span>
              ) : null}
            </span>
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
